import * as types from '../../actionTypes'

const initialState = {
  file: null,
  fileName: '',
  uploadResults: null,
  isLoading: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.PACING_FILE_SELECTED:
    case types.PACING_FILE_SUBMITTING:
    case types.PACING_FILE_SUCCEEDED:
    case types.PACING_FILE_ERROR:
      const { data, error, file, type } = action

      return {
        ...state,
        file:
          types.PACING_FILE_SELECTED && file
            ? file
            : type === types.PACING_FILE_SUCCEEDED ||
              type === types.PACING_FILE_ERROR
            ? null
            : state.file,
        fileName:
          types.PACING_FILE_SELECTED && file
            ? file.name
            : type === types.PACING_FILE_SUCCEEDED ||
              type === types.PACING_FILE_ERROR
            ? null
            : state.fileName,
        uploadResults: type === types.PACING_FILE_SUCCEEDED ? data : null,
        isLoading: type === types.PACING_FILE_SUBMITTING,
        error: type === types.PACING_FILE_ERROR ? error : null,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/pacing/reducer.js